import React from "react";

function DeleteIcon(props) {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 2.93707H2.11111M2.11111 2.93707H11M2.11111 2.93707V10.7148C2.11111 11.0095 2.22817 11.2921 2.43655 11.5005C2.64492 11.7089 2.92754 11.826 3.22222 11.826H8.77778C9.07246 11.826 9.35508 11.7089 9.56345 11.5005C9.77183 11.2921 9.88889 11.0095 9.88889 10.7148V2.93707H2.11111ZM3.77778 2.93707V1.82595C3.77778 1.53127 3.89484 1.24865 4.10322 1.04028C4.31159 0.831907 4.5942 0.714844 4.88889 0.714844H7.11111C7.4058 0.714844 7.68841 0.831907 7.89679 1.04028C8.10516 1.24865 8.22222 1.53127 8.22222 1.82595V2.93707M4.88889 5.71484V9.04818M7.11111 5.71484V9.04818"
        stroke="#D4001C"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </svg>
  );
}

export default DeleteIcon;
